import CustomTooltip from '@/components/tooltip/customTooltip'
import { vTooltip } from '@/directives/tooltip.js'

const TooltipPlugin = {
  install (Vue) {
    // Register component
    Vue.component('CustomTooltip', CustomTooltip)
    // Register directive
    Vue.directive('tooltip', vTooltip)
  }
}

export default TooltipPlugin
